import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Template from '../Components/Template';
import { useDeleteCashDepositRecordMutation, useGetCashDepositRecordsQuery, useGetTotalAmountAgentQuery, useSaveCashdepositRecordMutation } from '../Services/modules/exam';
import WarningModal from '../Components/WarningModal';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useSelector } from 'react-redux';
import { Config } from '../Config';

export default function DepositProofForm() {
      const userData = useSelector((state) => state.userData.user_data);
      const agentId=userData.userId
    console.log("userData",userData)
    const [previewFile, setPreviewFile] = useState(null);
const [showPreview, setShowPreview] = useState(false);
    const [totalAmount,setTotalAmount]=useState(0)
     const [cashDepositRecord,setCashDepositRecord]=useState([])
     const [errors, setErrors] = useState({});
     const[recordId,setRecordId]=useState("")
      const[isDelete,setIsDelete]=useState(false) 
         const[isDeleteModal,setDeleteModal]=useState(false)
 const { data, isSuccess, isLoading, error, refetch } = useGetTotalAmountAgentQuery();
 const { data:depositData, isSuccess:depositSuccess, isLoading:depositIsLoading, error:depositError } = useGetCashDepositRecordsQuery({agentId});
  const [SaveForm, { data:saveData, isSuccess:saveSuccess, isLoading:saveLoading, isError:saveIsError, error:saveError }] = useSaveCashdepositRecordMutation();
  const [DeleteRecord, { data:deleteData, isSuccess:deleteSuccess, isLoading:deleteLoading, isError:deleteIsError, error:deleteError }] = useDeleteCashDepositRecordMutation();

 useEffect(()=>{
    if(isSuccess)
    {
        console.log("totla amout agent till date",data)
        setTotalAmount(data.totalAmount)
    }
 },[data])
 useEffect(()=>{
    if(isSuccess)
    {
        console.log("deposit data",depositData)
        setCashDepositRecord(depositData?.allRecords)
       // setTotalAmount(data.totalAmount)
    }
 },[depositData])

  useEffect(()=>{
    if(saveSuccess)
    {
        console.log("saved data",saveData)
        clearData()
     toast.success("Saved successfully")
      
        //setCashDepositRecord(depositData.allRecords)
       // setTotalAmount(data.totalAmount)
    }
 },[saveData])
const clearData=()=>{
     setFormData({
      agentId: '',
      amount: '',
      bankName: '',
      bankBranch: '',
      accNo: '',
      accType: '',
      ifsc: '',
      utrNumber: '',
      photoProofFile: null,
    });
    setErrors({});
}

const handlePreview = (filePath) => {
  setPreviewFile(filePath);
  setShowPreview(true);
};
  const [formData, setFormData] = useState({
    agentId: '',
    amount: '',
    bankName: '',
    bankBranch: '',
    accNo: '',
    accType: '',
    ifsc: '',
    utrNumber: '',
    photoProofFile: null,
  });

  const [submitting, setSubmitting] = useState(false);
  const [message, setMessage] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleFileChange = (e) => {
    setFormData({ ...formData, photoProofFile: e.target.files[0] });
  };

  const validate = () => {
  const newErrors = {};

  if (!formData.amount) newErrors.amount = 'Amount is required';
  if (!formData.bankName) newErrors.bankName = 'Bank Name is required';
  if (!formData.bankBranch) newErrors.bankBranch = 'Bank Branch is required';
  if (!formData.accNo) newErrors.accNo = 'Account Number is required';
  if (!formData.accType) newErrors.accType = 'Account Type is required';
  if (!formData.ifsc) newErrors.ifsc = 'IFSC Code is required';
  if (!formData.utrNumber) newErrors.utrNumber = 'UTR Number is required';
  if (!formData.photoProofFile) newErrors.photoProofFile = 'Proof file is required';

  setErrors(newErrors);
  return Object.keys(newErrors).length === 0;
};

const handleSubmit = async () => {
    console.log("inside handle submit")
  if (!validate()) return;

  try {
    setSubmitting(true);
    const form = new FormData();
    Object.entries(formData).forEach(([key, value]) => {
      if (value) form.append(key, value);
    });

    SaveForm(form)
    // const res = await axios.post('/api/depositproof', form, {
    //   headers: {
    //     'Content-Type': 'multipart/form-data',
    //     Authorization: `Bearer ${localStorage.getItem('token')}`
    //   }
    // });

    // setMessage(res.data.message);
     setSubmitting(false);
    // setFormData({
    //   agentId: '',
    //   amount: '',
    //   bankName: '',
    //   bankBranch: '',
    //   accNo: '',
    //   accType: '',
    //   ifsc: '',
    //   utrNumber: '',
    //   photoProofFile: null,
    // });
    // setErrors({});
  } catch (err) {
    setSubmitting(false);
    setMessage(err.response?.data?.message || 'Error submitting form');
  }
};
const handleDelete=(dataRow)=>{
    setDeleteModal(true)
    setRecordId(dataRow._id)
  }
 useEffect(() => {
    if(isDelete)
    {
      DeleteRecord({depositId:recordId})
    }
  
  }, [isDelete]);
  useEffect(()=>{
    if(deleteSuccess)
    {
         setDeleteModal(false)
    setRecordId("")
    toast.success("Record deleted successfully")
    }
  },[deleteData])
const depositProofFormScreen=()=>{
         return (
            <>
            {showPreview && (
  <div className="modal show d-block" tabIndex="-1" role="dialog" onClick={() => setShowPreview(false)}>
    <div className="modal-dialog modal-lg" role="document" onClick={e => e.stopPropagation()}>
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">Proof Preview</h5>
          <button type="button" className="btn-close" onClick={() => setShowPreview(false)}></button>
        </div>
        <div className="modal-body text-center">
          {previewFile.endsWith('.pdf') ? (
            <iframe src={previewFile} title="PDF Preview" width="100%" height="500px"></iframe>
          ) : (
            <img src={previewFile} alt="Preview" style={{ maxWidth: '100%', maxHeight: '500px' }} />
          )}
        </div>
      </div>
    </div>
  </div>
)}
             <
                            WarningModal
                            setShowWarningModal={setDeleteModal}
                            modalTitle={"Delete Product"}
                            setIsDelete={setIsDelete}
                            showModal={isDeleteModal}
                          />
                          <ToastContainer/>
            <main id="main" className="main">
      <div className="container mt-4">
        {/* Total Amount Card */}
        <div className="row mb-4">
          <div className="col-md-6 mx-auto">
            <div className="card text-white bg-success shadow">
              <div className="card-body text-center">
                <h5 className="card-title">Total Deposited Amount</h5>
                <p className="card-text" style={{ fontSize: '2rem' }}>
                  ₹ {totalAmount?.toLocaleString('en-IN')}
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Split into 2 columns */}
        <div className="row justify-content-center">
          {/* Left: Deposit Form */}
          <div className="col-md-4">
            <div className="card shadow">
              <div className="card-body">
                <h5 className="mb-3">Add cash deposit records</h5>

               {[
  ['Amount', 'amount'],
  ['Bank Name', 'bankName'],
  ['Bank Branch', 'bankBranch'],
  ['Account No', 'accNo'],
  ['Account Type', 'accType'],
  ['IFSC Code', 'ifsc'],
  ['UTR Number', 'utrNumber']
].map(([label, name]) => (
  <div className="form-group mb-2" key={name}>
    <label>{label} <span className="text-danger">*</span></label>
    <input
      type="text"
      className={`form-control ${errors[name] ? 'is-invalid' : ''}`}
      name={name}
      value={formData[name]}
      onChange={handleChange}
    />
    {errors[name] && <div className="invalid-feedback">{errors[name]}</div>}
  </div>
))}


              <div className="form-group mb-3">
  <label>Upload Proof File <span className="text-danger">*</span></label>
  <input
    type="file"
    className={`form-control ${errors.photoProofFile ? 'is-invalid' : ''}`}
    name="photoProofFile"
    onChange={handleFileChange}
    accept="image/*,application/pdf"
  />
  {errors.photoProofFile && <div className="invalid-feedback">{errors.photoProofFile}</div>}
</div>

                <button className="btn btn-primary" onClick={handleSubmit} disabled={submitting}>
                  {submitting ? 'Submitting...' : 'Submit'}
                </button>

                {message && <div className="alert alert-info mt-3">{message}</div>}
              </div>
            </div>
          </div>

          {/* Right: Record Table */}
          <div className="col-md-8">
            <div className="card shadow">
              <div className="card-body">
                <h5 className="mb-3">Submitted Records</h5>
                <table className="table table-bordered">
                 <thead>
  <tr>
    <th>#</th>
    <th>Amount</th>
    <th>Bank</th>
    <th>Acc no</th>
    <th>IFSC</th>
    <th>UTR</th>
    <th>Date</th>
    <th>Proof</th>
    <th>Action</th>
  </tr>
</thead>
<tbody>
  {cashDepositRecord.length > 0 ? (
    cashDepositRecord.map((record, index) => (
      <tr key={record._id}>
        <td>{index + 1}</td>
        <td>₹ {record.amount}</td>
        <td>{record.bankName + " | " + record.bankBranch + " | " + record.accType}</td>
        <td>{record.accNo}</td>
        <td>{record.ifsc}</td>
        <td>{record.utrNumber}</td>
        <td>{record.record_created_date}</td>

        {/* Proof Preview Column */}
        <td>
          {record.photoProofFile && (
            <img
              src={`${Config.API_URL_IMAGE}/depositProof/${record.photoProofFile}`}
              alt="Proof"
              style={{ width: '40px', height: '40px', objectFit: 'cover', cursor: 'pointer' }}
              onClick={() => handlePreview(`${Config.API_URL_IMAGE}/depositProof/${record.photoProofFile}`)}
            />
          )}
        </td>

        {/* Action Column */}
        <td>
          <button
            className="btn btn-sm btn-danger"
            onClick={() => handleDelete(record)}
            title="Delete"
          >
            🗑️
          </button>
        </td>
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="9" className="text-center text-muted">No records yet</td>
    </tr>
  )}
</tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
    </>
  );
    }
 return(
    <Template>
        {depositProofFormScreen()}
    </Template>
 )
}
